import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';

//
// 로컬라이징 (다국어) 메세지 표기 영역
//
interface IProps {
  className?: string;
  confirm?: Array<string> | string;
  value?: string;
  width?: string;
  htmlType?: 'button' | 'submit' | 'reset' | undefined;
  style?: React.CSSProperties;
}

/**
 *
 * @returns {localizing 결과 값에 따라 달라지는 텍스트 박스}
 */
const Message: React.FC<IProps> = ({ className, value, style, width }) => {
  return (
    <StyledMessage className={className} style={style} width={width}>
      {value ? value : '등록 이후 다국어 ID값을 표시합니다.'}
      <span>'</span>
      {/* 아예없을때 height안줘져서 opacity0주면서 높이값 지킴이! */}
    </StyledMessage>
  );
};

export default Message;
const StyledMessage = styled.div`
  background: ${theme.colors.gray_4};
  padding: 0.5rem;
  line-height: 1.2rem;
  max-width: 30rem;
  width: ${(props) => (props.width ? props.width : '')};
  color: ${theme.colors.gray_2};
  /* margin-left: 1rem; */
  span {
    opacity: 0;
  }
`;
